/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {viewWithDataGetAllData} from '../../box-utils/PrimaryData';
import {ParentBox, relayWrap} from './../../box-utils/ParentBox.react.js';
import {defineMessages, FormattedMessage, IntlShape} from 'react-intl';
import deepCopy from 'deep-copy';
import {sendError, displayError} from '../../../app/errorDisplayer';
import BoxDecorator from './../../box-utils/BoxDecorator.react';
import LoadingButtonNew from '../../../fw/LoadingButtonNew.react';
import InvokeChannelActionMutation from '../../../channels/InvokeChannelActionMutation.react';
import mutationError from '../../../channel-defs/mutationError';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {MAILCHIMP_ACTION} from "../../../../common/constants/MailChimp";
import EmptyContent from '../system/EmptyContent.react';
import PanelColumns from '../system/PanelColumns.react';

import './MailChimp.scss';
import '../../../layout.scss';
import {safeJSONparse} from "../../../../common/util/safeJSONparse";


const messages = defineMessages({
	errorUnknown: {id: 'invokeChannelAction.errorUnknown', 'defaultMessage': 'Unknown error during action'},
	errorDescription: {id: 'invokeChannelAction.errorDescription', 'defaultMessage': 'Error during action: {errorMessage}'},
	subscribe: {id: 'mailChimp.subscribe', 'defaultMessage': 'Subscribe to {listName}'},
	unubscribe: {id: 'mailChimp.unsubscribe', 'defaultMessage': 'Unubscribe from {listName}'},
	subscribeButton: {id: 'mailChimp.subscribeButton', 'defaultMessage': 'Subscribe'},
    unsubscribeButton: {id: 'mailChimp.unsubscribeButton', 'defaultMessage': 'Unsubscribe'},
    newsletterList: {id: 'mailChimp.newsletterList', 'defaultMessage': 'Newsletter List'},
	betaList: {id: 'mailChimp.betaList', 'defaultMessage': 'Beta Users List'},
	developersList: {id: 'mailChimp.developersList', 'defaultMessage': 'Developers List'},
	unsubscribeAllButton: {id: 'mailChimp.unsubscribeAllButton', 'defaultMessage': 'Unsubscribe all'},
	unsubscribeAll: {id: 'mailChimp.unsubscribeAll', 'defaultMessage': 'Unubscribe from {cnt} {cnt, plural, one {list} other {lists}}'},
	deleteButton: {id: 'mailChimp.deleteButton', 'defaultMessage': 'Delete user'},
	delete: {id: 'mailChimp.delete', 'defaultMessage': 'Delete user data from MailChimp'},
	deletedButton: {id: 'mailChimp.deletedButton', 'defaultMessage': 'Deleted'},
});

class MailChimp extends ParentBox {

	static handlerName = "mailchimp-subscribe";

	static propTypes = {
		intl: PropTypes.object,
		isPreview: PropTypes.bool,
		relay: PropTypes.object,
		viewWithData: PropTypes.object.isRequired,
	};

	static contextTypes = {
		router: PropTypes.object,
	};

	constructor(props) {
		super(props);

		this.state = {
			stateChanges: []
		};
	}

	getIcon() {
		return "mailchimp";
	}

	getServiceName() {
		return "MailChimp";
	}

	onClickSuccess(invokeChannelAction, listIds, email) {
		return new Promise((resolve, reject) => {
			try {
				if (invokeChannelAction.success) {
					let response = safeJSONparse(invokeChannelAction.response);
					let stateChanges = [...this.state.stateChanges];

					response.values.forEach(row => {
						let stateIndex = stateChanges.findIndex(change => change.email === email && change.listId === row.listId);

						if (stateIndex !== -1) {
							stateChanges.splice(stateIndex, 1);
						}

						stateChanges.push({
							email: email,
							listId: row.listId,
							status: row.status,
                            memberId: row.memberId,
						});
					});

					this.setState({
						stateChanges: stateChanges
					});

					resolve();
				}
				else  {
					let message = invokeChannelAction.message
						? this.props.intl.formatMessage(messages.errorDescription, {errorMessage: invokeChannelAction.message})
						: this.props.intl.formatMessage(messages.errorUnknown);

					displayError(message);
					reject(message);
				}
			} catch (e) {
				sendError(e);
				reject(e);
			}
		});
	}

	getMemberId(fullData, email, listId) {
		let member = fullData
			.find(item => item.members["com.dativery.model.components.contactable@email"] === email
            && item.lists['com.mailchimp.lists@listId'] === listId);
		if (member) {
            return member.members["com.mailchimp.listMembers@originalMemberId"];
        }
        return null;
	}

	onClick({fullData, listIds, email, action}) {
		return new Promise((resolve, reject) => {
			if (this.props.isPreview) {
				let self = this;
				setTimeout(() => {
					let stateChanges = [...self.state.stateChanges];

					listIds.forEach(listId => {
						let stateIndex = stateChanges.findIndex(change => change.email === email && change.listId === listId);

						if (stateIndex !== -1) {
							stateChanges.splice(stateIndex, 1);
						}
					});

					listIds.forEach(listId => {
						stateChanges.push({
							email: email,
							listId: listId,
							status: action,
						});
					});

					self.setState({
						stateChanges: stateChanges
					});
					resolve();
				}, 1000);
			}
			else {
				let onSuccess = ({invokeChannelAction}) => {
					return this.onClickSuccess(invokeChannelAction, listIds, email).then(resolve, reject);
				};
				let onFailure = (transaction) => {
					let error = mutationError(transaction);
					reject(error);
				};

				let args = {
					listIds: listIds,
                    memberId: this.getMemberId(fullData, email, listIds[0]),
					email: email,
					action: action
				};

				let actionName = "mailchimp-subscribe";

				let mutationArgs = {
					channel: this.props.viewWithData.view.connectedChannel,
					actionName: actionName,
					args: args,
				};

				if (this.props.relay) {
					this.props.relay.commitUpdate(
						new InvokeChannelActionMutation(mutationArgs), {onSuccess: onSuccess, onFailure: onFailure}
					);
				}
			}
		});
	}

	isSubscribed(subscribtionRow, email) {
		if (email in subscribtionRow.members) {
			return subscribtionRow.members[email] === MAILCHIMP_ACTION.subscribe;
		}

		return false;
	}

	isUnsubscribed(subscribtionRow, email) {
		if (email in subscribtionRow.members) {
			return subscribtionRow.members[email] === MAILCHIMP_ACTION.unsubscribe;
		}

		return false;
    }

	canSubscribe(subsribtionRow) {
        return subsribtionRow['current']['com.dativery.model.components.contactable@email'] && !this.isUnsubscribed(subsribtionRow);
    }

	getSubscribeIcon(subscribtionRow, email, idx) {
		let icon;
		let tooltipText;

        if (this.isUnsubscribed(subscribtionRow, email)) {
            icon = "times-circle";
			tooltipText = <FormattedMessage defaultMessage="Unsubscribed" id="mailChimp.status.unsubscribed" />;
        }
		else if (this.isSubscribed(subscribtionRow, email)) {
			icon = "check";
			tooltipText = <FormattedMessage defaultMessage="Subscribed" id="mailChimp.status.Subscribed" />;
		}
		else {
			icon = "minus";
			tooltipText = <FormattedMessage defaultMessage="Not subscribed" id="mailChimp.status.notSubscribed" />;
		}

		// has to have unique id
		let tooltip = (<Tooltip id={"tooltip" + idx}>{tooltipText}</Tooltip>);

		return (
			<OverlayTrigger overlay={tooltip} placement="bottom">
				<span className={"fa fa-" + icon + " statusIcon"} />
			</OverlayTrigger>
		);
	}

	getActionRowButton(fullData, row, email) {
		let text = this.props.intl.formatMessage(messages.subscribeButton);
		let title = this.props.intl.formatMessage(messages.subscribe, {listName: row.name});
		let action = MAILCHIMP_ACTION.subscribe;

		if (this.isSubscribed(row, email)) {
			text = this.props.intl.formatMessage(messages.unsubscribeButton);
			title = this.props.intl.formatMessage(messages.unubscribe, {listName: row.name});
			action = MAILCHIMP_ACTION.unsubscribe;
		}

		return (
			<span className={"subscribeButton"}>
				<LoadingButtonNew
					className="btn btn-xs btn-default"
					onClick = {() => this.onClick({
						fullData: fullData,
						listIds: [row.listId],
						email: email,
						action: action})
					}
					progressText={<FormattedMessage defaultMessage="Saving" id="mailChimp.saving" />}
					text={text}
					title={title}
					type="div"
					vertical={false}
					withoutDone
				/>
			</span>
		);
	}

	unsubscribeAll(fullData, listArray, email) {
		let subsibedRows = listArray
							.filter(row => this.isSubscribed(row, email))
							.map(item => item.listId);

		return this.onClick({
			fullData: fullData,
			listIds: subsibedRows,
			email: email,
			action: MAILCHIMP_ACTION.unsubscribe
		});
	}

	deleteAll(fullData, listArray, email) {
		let rowsWithData = listArray
							.filter(row => this.isSubscribed(row, email) || this.isUnsubscribed(row, email))
							.map(item => item.listId);

		return this.onClick({
			fullData: fullData,
			listIds: rowsWithData,
			email: email,
			action: MAILCHIMP_ACTION.delete
		});
	}

	getPreviewData() {
		return [
			{
				lists: {
					'com.mailchimp.lists@listId': 1,
					'com.dativery.model.sharedFields.name@name': this.props.intl.formatMessage(messages.newsletterList)
				},
				current: {
                    'com.dativery.model.components.contactable@email': 'hello@dativery.com'
                },
				members: {
					"com.dativery.model.components.contactable@email": "hello@dativery.com",
					'com.mailchimp.listMembers@status': 'subscribed',
					"com.mailchimp.listMembers@originalMemberId": "abc123"
				},
			},
			{
				lists: {
					'com.mailchimp.lists@listId': 2,
					'com.dativery.model.sharedFields.name@name': this.props.intl.formatMessage(messages.betaList)
				},
				current: {
                    'com.dativery.model.components.contactable@email': 'hello@dativery.com'
                },
				members: {
					"com.dativery.model.components.contactable@email": "hello@dativery.com",
					'com.mailchimp.listMembers@status': 'unsubscribed',
					"com.mailchimp.listMembers@originalMemberId": "abc123"
				},
			},
			{
				lists: {
					'com.mailchimp.lists@listId': 3,
					'com.dativery.model.sharedFields.name@name': this.props.intl.formatMessage(messages.developersList)
				},
				current: {
                    'com.dativery.model.components.contactable@email': 'hello@dativery.com'
                },
				members: {
					"com.dativery.model.components.contactable@email": null,
					'com.mailchimp.listMembers@status': null,
					"com.mailchimp.listMembers@originalMemberId": null
				},
			}
		];
	}

	applyStateData(data) {
		this.state.stateChanges.forEach(change => {
			let dataIndex = data.findIndex(item => item.lists["com.mailchimp.lists@listId"] === change.listId && item.members["com.dativery.model.components.contactable@email"] === change.email);

			if (dataIndex !== -1) {
				if (change.status === MAILCHIMP_ACTION.delete) {
					data[dataIndex].members["com.dativery.model.components.contactable@email"] = null;
					data[dataIndex].members["com.mailchimp.listMembers@status"] = null;
					data[dataIndex].members["com.mailchimp.listMembers@originalMemberId"] = null;
				}
				else {
					data[dataIndex].members["com.mailchimp.listMembers@status"] = change.status;

					if ('memberId' in change) {
						data[dataIndex].members["com.mailchimp.listMembers@originalMemberId"] = change.memberId;
					}
				}
			}
			else if (change.status !== MAILCHIMP_ACTION.delete) {
				let list = deepCopy(data.find(item => item.lists["com.mailchimp.lists@listId"] === change.listId));

				list.members["com.dativery.model.components.contactable@email"] = change.email;
				list.members["com.mailchimp.listMembers@status"] = change.status;

				if ('memberId' in change) {
					list.members["com.mailchimp.listMembers@originalMemberId"] = change.memberId;
				}

				data.push(list);
			}
		});

		return data;
	}

	isFromEmail(data) {
		return data && data.length > 0 && data[0].current && !('com.dativery.model.components.contactable@email' in data[0].current);
	}

	getEmails(data) {
		if (this.isFromEmail(data)) {
			return data
				.map(item => {
					let emails = [];

					if (item.current['com.dativery.model.entities.emailMessages@ccAddresses']) {
						emails.push(...item.current['com.dativery.model.entities.emailMessages@ccAddresses']);
					}

					if (item.current['com.dativery.model.entities.emailMessages@fromAddress']) {
						emails.push(...item.current['com.dativery.model.entities.emailMessages@fromAddress']);
					}

					if (item.current['com.dativery.model.entities.emailMessages@toAddresses']) {
						emails.push(...item.current['com.dativery.model.entities.emailMessages@toAddresses']);
					}

					return emails;
				})
				.reduce((acc, curr) => {
					acc.push(...curr);
					return acc;
				}, [])
				.filter((elem, pos, arr) => arr.indexOf(elem) === pos)
				.sort((emailA, emailB) => emailA.localeCompare(emailB));
		}

		if (data[0].current && 'com.dativery.model.components.contactable@email' in data[0].current && data[0].current['com.dativery.model.components.contactable@email']) {
			return [data[0].current['com.dativery.model.components.contactable@email']];
		}

		return [];
	}

	getLists(data) {
		let lists = {};

		data.forEach(item => {
			let listId = item.lists["com.mailchimp.lists@listId"];

			if (!(listId in lists)) {
				lists[listId] = {
					listId: listId,
					name: item.lists["com.dativery.model.sharedFields.name@name"],
					members: {}
				};
			}

			if (item.members["com.dativery.model.components.contactable@email"]) {
				lists[listId].members[item.members["com.dativery.model.components.contactable@email"]] = item.members["com.mailchimp.listMembers@status"];
			}
		});

		return lists;
	}

	render() {
		let data = this.applyStateData(this.props.isPreview ? this.getPreviewData() : viewWithDataGetAllData(this.props.viewWithData));

		let emails = this.getEmails(data);
		let lists = this.getLists(data);
		let listsArray = Object.keys(lists)
			.map(listId => lists[listId])
			.sort((itemA, itemB) => itemA.name.localeCompare(itemB.name));

		if (Object.keys(lists).length === 0 || emails.length === 0) {
			return (
				<BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
					<EmptyContent />
				</BoxDecorator>
			);
		}

		return (
			<BoxDecorator className="mailchimpSubscribtionList" icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
				<PanelColumns>
					{emails.map(email => {
						let subscibedListsCnt = 0;
						let anyMemberData = 0;

						return (
							<div key={email}>
								<strong className="title"><FormattedMessage defaultMessage="{email}:" id="mailChimp.emailTitle" values={{email: email}} /></strong>
								<table><tbody>
									{listsArray.map((row, idx) => {
										if (this.isSubscribed(row, email)) {
											subscibedListsCnt++;
											anyMemberData++;
										}
										if (this.isUnsubscribed(row, email)) {
											anyMemberData++;
										}
										return (
											<tr key={idx}>
												<td>{this.getSubscribeIcon(row, email, idx)}</td>
												<td>{row.name}</td>
												<td>{this.getActionRowButton(data, row, email)}</td>
											</tr>
										);
									})}
								</tbody></table>
								<div className="massAction">
									{subscibedListsCnt > 0 ?
										<span className={"subscribeButton"} key="unsubscribeAllButton">
											<LoadingButtonNew
												className="btn btn-xs btn-default"
												onClick = {() => this.unsubscribeAll(data, listsArray, email)}
												progressText={<FormattedMessage defaultMessage="Saving" id="mailChimp.saving" />}
												text={this.props.intl.formatMessage(messages.unsubscribeAllButton)}
												title={this.props.intl.formatMessage(messages.unsubscribeAll, {cnt: subscibedListsCnt})}
												type="div"
												vertical={false}
												withoutDone
											/>
										</span>
									: null}
									{anyMemberData > 0 ?
										<span className={"subscribeButton"} key="deleteButton">
											<LoadingButtonNew
												className="btn btn-xs btn-default"
												doneText={this.props.intl.formatMessage(messages.deletedButton)}
												onClick = {() => this.deleteAll(data, listsArray, email)}
												progressText={<FormattedMessage defaultMessage="Deleting" id="mailChimp.deleting" />}
												text={this.props.intl.formatMessage(messages.deleteButton)}
												title={this.props.intl.formatMessage(messages.delete)}
												type="div"
												vertical={false}
											/>
										</span>
									: null}
								</div>
							</div>
						);
					})}
				</PanelColumns>
			</BoxDecorator>
		);
	}
}

export default relayWrap(MailChimp);
